module.exports = __webpack_public_path__ + "img/1bz.68b51543.png";